import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'account.settings.editable.field.password.reset.button': {
    id: 'account.settings.editable.field.password.reset.button',
    defaultMessage: 'Reset Password',
    description: 'The password reset button in account settings',
  },
});

export default messages;
